/**
 * This file holds functions that performs actual state modifications
 * Please refer to https://vuex.vuejs.org/guide/mutations.html for more information
 * Also mutations MUST BE SYNCHRONOUS https://vuex.vuejs.org/guide/mutations.html#mutations-must-be-synchronous
 */
import * as types from "./types";
import defaultState from "./defaultState";

const mutations = {
  [types.SET_VIEWS](state, views) {
    state.navigation.views = views;
  },
  [types.SET_ACTIVE_VIEW](state, activeView) {
    let index = [], i = -1;
    while ((i = state.navigation.views.indexOf(activeView, i+1)) != -1) {
        index.push(i);
    }
    state.navigation.activeViewIndex = state.useSecondView ? index[index.length - 1] : index[0];
    state.navigation.activeView = activeView;
  },
  [types.PREV_VIEW](state) {
    const index = state.navigation.activeViewIndex - 1;
    if (index < 0 || index >= state.navigation.views.length) {
      throw new Error(`Invalid view index: ${index}`);
    }
    const activeView= state.navigation.views[index];
    this.commit("customCheckerboard/SET_ACTIVE_VIEW", activeView );
  },
  [types.NEXT_VIEW](state) {
    const index = state.navigation.activeViewIndex + 1;
    if (index < 0 || index >= state.navigation.views.length) {
      throw new Error(`Invalid view index: ${index}`);
    }
    const activeView= state.navigation.views[index];
    this.commit("customCheckerboard/SET_ACTIVE_VIEW", activeView );
  },
  [types.SET_ACTIVE_UGC_COMPONENT](state, activeUGCComponent) {
    state.activeUGCComponent = activeUGCComponent;
  },
  [types.RESET_NAVIGATION](state) {
    state.navigation = {
      ...defaultState.navigation
    };
  },
  [types.SET_CANVAS_CONFIG](state, config) {
    state.canvasConfig = {
      ...state.canvasConfig,
      ...config,
    };
  },
  [types.SET_BUTTON_BACKGROUND_IMAGE_URL](state, imageUrl) {
    state.buttonBackgroundImageUrl = imageUrl;
  },
  [types.SET_ENABLE_CONTROLS](state, data) {
    state.enableControls = data;
  },
  [types.SET_UPLOADED_IMAGE_DATA](state, data) {
    state.uploadedImage = { ...data };
  },
  [types.SET_SKIP_WARP_SELECTOR](state, data) {
    state.skipWarpSelector = data;
  },
  [types.SET_COMPONENT_CONFIG](state, { component, canvasConfig, ugc = {} }) {
    state.components = {
      ...state.components,
      [component]: {
        canvasConfig,
        ugc,
      },
    };
  },
  [types.REMOVE_COMPONENT_CONFIG](state, component) {
    delete state.components[component];
  },
  [types.SET_AVAILABLE_MODELS](state, availableModels) {
    state.availableModels = availableModels;
  },
  [types.RESET_CANVAS](state) {
    state.canvasConfig = {
      ...defaultState.canvasConfig
    };
  },
  [types.SET_SECOND_VIEW](state, payload) {
    state.useSecondView = payload;
  },
  [types.SET_SAME_UPLOAD_IMAGE](state, payload) {
    state.useSameUploadedImage = payload;
  },
  [types.SET_TEMP_COMPONENTS](state) {
    state.tempComponents = {
      ...state.components
    };
  },
  [types.SET_COMPONENTS](state) {
    state.components = {
      ...state.tempComponents
    };
  },
  [types.SET_CHECKERBOARD_SIZE](state, payload) {
    state.sizeData = payload;
  },
  [types.SET_PRODUCT_TYPE](state, { productType = '' }) {
    state.productType = productType;
  },
  [types.SET_SOURCE](state, { source = '' }) {
    state.source = source;
  },
};

export default mutations;
